export const Illustration = [
  {
    icon: 'el-icon-error',
    style: { color: '#F5603F' },
    list: [
      'eip.common.reject',
      'eip.common.oppose',
      'eip.status.refuseToReturnToTheInitiator',
      'eip.status.countersignFailed',
      'eip.status.manualTermination',
    ],
    status: ['reject', 'oppose', 'backToStart', 'signNotPass', 'manual_end'],
  },
  {
    icon: 'el-icon-warning',
    style: { color: 'rgb(255, 138, 0)' },
    list: [
      'eip.status.pendingApproval',
      'eip.status.pending',
      'eip.common.revoke',
      'eip.status.withdrawalToInitiator',
    ],
    status: ['awaiting_check', 'hangUp', 'revoker', 'revoker_to_start'],
  },
  {
    icon: 'el-icon-success',
    style: { color: '#0EB400' },
    list: [
      'eip.common.agree',
      'eip.status.countersignedAndApproved',
      'eip.common.done',
    ],
    status: ['agree', 'signPass'],
  },
  {
    icon: 'el-icon-warning',
    style: { color: '#5465FF' },
    list: ['eip.common.submit', 'eip.status.resubmit', 'eip.status.skip'],
    status: ['start', 'reSubmit', 'skip'],
  },
]

export const FLOW_NODE_TYPE_MAP = {
  'bpmn:SequenceFlow': 'edge',
  'bpmn:StartEvent': 'event',
  'bpmn:EndEvent': 'event',
  'bpmn:UserTask': 'task',
  'bpmn:ExclusiveGateway': 'gateway',
  'bpmn:ParallelGateway': 'gateway',
  'bpmn:InclusiveGateway': 'gateway',
  'bpmn:ComplexGateway': 'gateway',
  'bpmn:ServiceTask': 'serviceTask', // 服务任务
  'bpmn:SubProcess': 'subProcess', // 内部子流程
  'bpmn:CallActivity': 'callActivity', // 外部子流程
}

export const OPPOSITE = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
}

// 连线默认颜色
export const EDGE_DEFAULT_COLOR = '#e6e6e6'

// 连线经过颜色
export const EDGE_GOING_COLOR = '#5a6dff'

// 连线预测颜色
export const EDGE_PREDICT_COLOR = '#9d4dff'
